import axios from 'axios';
import {backendHost} from '../../config';

export const getMailingStatisticsCountGame = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/mailing/statistics/open-game/count`, {params});
};